import {
  email as emailValidator,
  helpers,
  required,
  requiredIf
} from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";
import Validator from "~/utils/validator";

const { locale } = await useLocale("validation");

export default {
  email: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
    email: helpers.withMessage(
      () => locale?.value?.invalid_email ?? validationJson.invalid_email,
      emailValidator,
    ),
  },
  cellphone: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
    validPhone: helpers.withMessage(
      () => locale?.value?.invalid_phone ?? validationJson.invalid_phone,
      Validator.cellphone,
    ),
    exactLengthRequired: helpers.withMessage(
      () => locale?.value?.invalid_phone ?? validationJson.invalid_phone,
      (value: string|null, { cellphoneRequiredDigits }: any) => {
        if (!cellphoneRequiredDigits) return true;
        if (!value) return false;
        const re = new RegExp(`^\\+39\\d{${cellphoneRequiredDigits}}`);
        return re.test(value.replaceAll(' ', ''));
      }
    )
  },
  taxCode: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
    tax_code_valid: helpers.withMessage(
      () => locale?.value?.invalid_tax_code ?? validationJson.invalid_tax_code,
      Validator.taxCode,
    ),
    tax_code_age: helpers.withMessage(
      () => locale?.value?.of_legal_age ?? validationJson.of_legal_age,
      Validator.taxCodeAge,
    ),
    tax_code_name: helpers.withMessage(
      () =>
        locale?.value?.incongruent_tax_code ??
        validationJson.incongruent_tax_code,
      Validator.taxCodeName,
    ),
  },
  name: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  surname: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
  },
  loanProjectType: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      //@ts-ignore
      requiredIf(function (value: any, { showLoanProjectTypeComponent, isAmountRevolving }: any) {
        return !!(showLoanProjectTypeComponent ?? false) && !(isAmountRevolving ?? false);
      }),    
    )
  },

};
